import { render, staticRenderFns } from "./BodyAnatomyInfo.vue?vue&type=template&id=6190e9ce&scoped=true&"
import script from "./BodyAnatomyInfo.vue?vue&type=script&lang=js&"
export * from "./BodyAnatomyInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6190e9ce",
  null
  
)

export default component.exports